import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { SelectionModel } from '@angular/cdk/collections';
import { Observable, timer } from 'rxjs';
import { take } from 'rxjs/operators';
import {
  CompartmentUserListFacade,
  CompartmentAssignedUserListSearchCriteria,
  CompartmentAvailableUserListSearchCriteria,
  LoadingFacade,
} from '../../store';
import { ListQueryParam, ListRange, ListServerPagination, ListServerPaginationStateModel } from '../../common';
import { ButtonAction, ButtonType } from '../../ui-kit/action-button';
import { FilterSearch, FilterSettings } from '../../ui-kit/list-filter';
import { TranslateService } from '@ngx-translate/core';
import { UserSelectionItem } from './models';

@Component({
    selector: 'lib-users-selection-dialog',
    templateUrl: './users-selection-dialog.component.html',
    styleUrls: ['./users-selection-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UsersSelectionDialogComponent
  extends ListServerPagination<UserSelectionItem>
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns = ['select', 'name', 'email', 'type'];
  listDto$: Observable<ListServerPaginationStateModel<UserSelectionItem>>;
  selection: SelectionModel<UserSelectionItem> = new SelectionModel<UserSelectionItem>(true, []);
  filterConfig: FilterSettings;
  searchCriteriaValue: CompartmentAssignedUserListSearchCriteria = new CompartmentAssignedUserListSearchCriteria();
  buttonAction = ButtonAction;
  buttonType = ButtonType;

  constructor(
    translateService: TranslateService,
    public dialogRef: MatDialogRef<UsersSelectionDialogComponent>,
    public loadingFacade: LoadingFacade,
    public compartmentUserListFacade: CompartmentUserListFacade,
  ) {
    super(translateService);
    this.listDto$ = compartmentUserListFacade.availableListDto$;
  }

  ngOnInit(): void {
    this.initFiltersForm();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  ngOnDestroy(): void {
    this.compartmentUserListFacade.resetAvailableList();
  }

  fetchList(listRange: ListRange): void {
    timer(0)
      .pipe(take(1))
      .subscribe(() => {
        this.searchCriteriaValue = {
          ...this.searchCriteriaValue,
          ...listRange,
        };
        this.compartmentUserListFacade.loadAvailableUserList(
          new CompartmentAvailableUserListSearchCriteria(this.searchCriteriaValue),
        );
      });
  }

  fetchListBySearchCriteria(filterValue?: CompartmentAvailableUserListSearchCriteria): void {
    this.searchCriteriaValue = {
      ...this.searchCriteriaValue,
      ...filterValue,
      page: 0,
    };
    this.compartmentUserListFacade.loadAvailableUserList(
      new CompartmentAvailableUserListSearchCriteria(this.searchCriteriaValue),
    );
  }

  noAvailableUsers(): boolean {
    return !this.searchCriteriaValue[ListQueryParam.Filter] && this.dataSource && this.dataSource.data.length === 0;
  }

  confirm(): void {
    this.compartmentUserListFacade.assignUsersToCompartment(this.dialogRef, this.selection.selected);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle(): void {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row: UserSelectionItem) => this.selection.select(row));
  }

  private initFiltersForm(): void {
    this.filterConfig = {
      items: [new FilterSearch({ name: ListQueryParam.Filter })],
    };
  }
}
